import script from "./filesPreviewContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./filesPreviewContainer.vue?vue&type=script&setup=true&lang=js"

import "./filesPreviewContainer.vue?vue&type=style&index=0&id=24c27ff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24c27ff4"]])

export default __exports__